/**
 * Checks if the value is a valid number
 * @param {Any} value
 */
export default function isValidNumeric(value) {
  // Special handling for 0 since normally it is falsy
  if (value === 0 || value === '0') {
    return true
  }
  return (
    value &&
    typeof value !== 'object' &&
    typeof value !== 'boolean' &&
    ![Infinity, -Infinity, NaN].includes(Number(value)) &&
    !value.toString().startsWith('+')
  )
}
